import React from 'react';

// Minimal Feather-style line icon set (inline SVG, no dependency) - stroke-based, inherits
// color via currentColor, sized consistently. Swapped in for the L10 Meeting module's
// original emoji glyphs.
function Base({ size = 16, children, style, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }} {...rest}>
      {children}
    </svg>
  );
}

export const CompassIcon = (p) => (
  <Base {...p}><circle cx="12" cy="12" r="10" /><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" /></Base>
);
export const TargetIcon = (p) => (
  <Base {...p}><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></Base>
);
export const BarChartIcon = (p) => (
  <Base {...p}><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></Base>
);
export const MegaphoneIcon = (p) => (
  <Base {...p}><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" /><path d="M15.54 8.46a5 5 0 0 1 0 7.07" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14" /></Base>
);
export const CheckSquareIcon = (p) => (
  <Base {...p}><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></Base>
);
export const BulbIcon = (p) => (
  <Base {...p}><circle cx="12" cy="9" r="6" /><line x1="9" y1="18" x2="15" y2="18" /><line x1="10" y1="21" x2="14" y2="21" /><line x1="12" y1="15" x2="12" y2="9" /></Base>
);
export const FlagIcon = (p) => (
  <Base {...p}><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" /><line x1="4" y1="22" x2="4" y2="15" /></Base>
);
export const ClipboardIcon = (p) => (
  <Base {...p}><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" ry="1" /></Base>
);
export const UsersIcon = (p) => (
  <Base {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></Base>
);
export const StarIcon = (p) => (
  <Base {...p}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></Base>
);
export const ClockIcon = (p) => (
  <Base {...p}><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></Base>
);
export const FileTextIcon = (p) => (
  <Base {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></Base>
);
export const ZapIcon = (p) => (
  <Base {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></Base>
);
export const PlayIcon = (p) => (
  <Base {...p}><polygon points="5 3 19 12 5 21 5 3" /></Base>
);
export const PauseIcon = (p) => (
  <Base {...p}><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></Base>
);
export const XIcon = (p) => (
  <Base {...p}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Base>
);
export const PlusIcon = (p) => (
  <Base {...p}><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Base>
);
export const CheckCircleIcon = (p) => (
  <Base {...p}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></Base>
);
export const SmileIcon = (p) => (
  <Base {...p}><circle cx="12" cy="12" r="10" /><path d="M8 14s1.5 2 4 2 4-2 4-2" /><line x1="9" y1="9" x2="9.01" y2="9" /><line x1="15" y1="9" x2="15.01" y2="9" /></Base>
);
